import getExtensibilityState from '../store/getExtensibilityState';
import type IAddinCommand from '../store/schema/interfaces/IAddinCommand';
import type { ObservableMap } from 'mobx';
import type IExtendedAddinCommand from '../store/schema/interfaces/IExtendedAddinCommand';
import type IAddinCommandTelemetry from '../store/schema/interfaces/IAddinCommandTelemetry';
import AutoRunAddinCommand from '../store/schema/AutoRunAddinCommand';
import { getTargetWindowFromControlId } from '../utils/getTargetWindowForAddin';
import getAddinInstanceString from '../utils/getAddinInstanceString';

export function isAnyUilessAddinRunning(addinIdentifierString: string): boolean {
    return getExtensibilityState().runningUILessExtendedAddinCommands.has(addinIdentifierString);
}

export function isAnyNonAutoRunUilessAddinRunning(addinIdentifierString: string): boolean {
    const runningUILessExtendedAddinCommand = getExtensibilityState().runningUILessExtendedAddinCommands?.get(
        addinIdentifierString
    );

    if (runningUILessExtendedAddinCommand) {
        for (let extendedAddinCommand of runningUILessExtendedAddinCommand.values()) {
            const addinCommand = extendedAddinCommand.addinCommand;
            if (!(addinCommand instanceof AutoRunAddinCommand)) {
                // return true when you find any instance of addin which is only Uiless and not autorun
                return true;
            }
        }
    }
    return false;
}

export function getUilessAddinCommand(controlId: string): IAddinCommand {
    const addins = getRunningUilessAddins();
    if (!addins) {
        // Strict mode was enabled in this package. See aka.ms/client-web-strict-mode for details.
        // -> Error TS2322 (37,9): Type 'null' is not assignable to type 'IAddinCommand'.
        // @ts-expect-error
        return null;
    }

    for (const hostItem of addins.values()) {
        for (const uilessControlId of hostItem.keys()) {
            if (uilessControlId === controlId) {
                // Strict mode was enabled in this package. See aka.ms/client-web-strict-mode for details.
                // -> Error TS2532 (46,24): Object is possibly 'undefined'.
                // @ts-expect-error
                return hostItem.get(uilessControlId).addinCommand;
            }
        }
    }
    // Strict mode was enabled in this package. See aka.ms/client-web-strict-mode for details.
    // -> Error TS2322 (53,5): Type 'null' is not assignable to type 'IAddinCommand'.
    // @ts-expect-error
    return null;
}

export function getUilessAddinCommandTelemetry(
    hostItemIndex: string,
    controlId: string
): IAddinCommandTelemetry {
    const targetWindow: Window = getTargetWindowFromControlId(controlId);
    const addinInstanceString = getAddinInstanceString(targetWindow, hostItemIndex);
    if (
        // Strict mode was enabled in this package. See aka.ms/client-web-strict-mode for details.
        // -> Error TS2345 (66,38): Argument of type 'string | null' is not assignable to parameter of type 'string'.
        // @ts-expect-error
        getRunningUilessAddins().has(addinInstanceString) &&
        // Strict mode was enabled in this package. See aka.ms/client-web-strict-mode for details.
        // -> Error TS2532 (70,9): Object is possibly 'undefined'.
        // @ts-expect-error
        getRunningUilessAddins().get(addinInstanceString).has(controlId)
    ) {
        // Strict mode was enabled in this package. See aka.ms/client-web-strict-mode for details.
        // -> Error TS2532 (75,16): Object is possibly 'undefined'.
        // @ts-expect-error
        return getRunningUilessAddins().get(addinInstanceString).get(controlId)
            .addinCommandTelemetry;
    }
    // Strict mode was enabled in this package. See aka.ms/client-web-strict-mode for details.
    // -> Error TS2322 (81,5): Type 'null' is not assignable to type 'IAddinCommandTelemetry'.
    // @ts-expect-error
    return null;
}

export function getUiLessAddinInstanceFromControlId(controlId: string): string {
    const addins = getRunningUilessAddins();
    if (!addins) {
        // Strict mode was enabled in this package. See aka.ms/client-web-strict-mode for details.
        // -> Error TS2322 (90,9): Type 'null' is not assignable to type 'string'.
        // @ts-expect-error
        return null;
    }

    for (const addinIdentifierString of addins.keys()) {
        const addinInstance = addins.get(addinIdentifierString);
        // Strict mode was enabled in this package. See aka.ms/client-web-strict-mode for details.
        // -> Error TS2532 (98,39): Object is possibly 'undefined'.
        // @ts-expect-error
        for (const uilessControlId of addinInstance.keys()) {
            if (uilessControlId === controlId) {
                return addinIdentifierString;
            }
        }
    }
    // Strict mode was enabled in this package. See aka.ms/client-web-strict-mode for details.
    // -> Error TS2322 (107,5): Type 'null' is not assignable to type 'string'.
    // @ts-expect-error
    return null;
}

export function isUilessAddinRunning(controlId: string): boolean {
    return getUilessAddinCommand(controlId) !== null;
}

function getRunningUilessAddins(): ObservableMap<
    string /*key: hostItemIndex and tabId*/,
    ObservableMap<string /*key: controlId*/, IExtendedAddinCommand>
> {
    return getExtensibilityState().runningUILessExtendedAddinCommands;
}
